<template>
  <div class="inputBg" :style="`width: ${inputWidth}; height: ${inputHeight}; background-color: ${isDisable ? `#F2F2F2` : `#ffffff`}`" @click="onClick">
    <!-- :class="isDisable ? `disableChooseSelectInput` : `chooseSelectInput`" -->
    <input
        :id="refName"
        ref="inputRef"
        :style="`height: ${inputHeight}; outline: 1px solid ${inputBorderColor ? inputBorderColor : '#BFBFBF'};padding: ${isShowNumber ? '0 60px 0 20px' : '0 20px'}`"
        :type="isPassword && !inputOpen ? `password`: ``"
        :class="setClassStyle()"
        :placeholder="placeholderStr"
        v-model="inputValue"
        @focus="inputFocus"
        @blur="inputBlur"
        @input="handleChange"
        @paste="onPaste"
        :disabled="isDisable"
        :maxlength="inputMaxLength"
        :minlength="inputMinLength"
        :inputmode="isCode ? 'numeric' : undefined"
        :autocomplete="isCode ? 'one-time-code' : (autoComplete ? 'off' : 'new-password')"
    />
    <div class="rightIcon">
      <div class="limitation" :style="!isPassword ? `margin-right: 20px;` : ``" v-if="isShowNumber">{{`${inputValue.length}/${inputMaxLength ? inputMaxLength : 64}`}}</div>
      <i v-if="isPassword" :class="`iconfont ${inputOpen ? `icon-icon_open_n` : `icon-icon_close_n`}`" style="margin-right: 20px; margin-left: 10px" @click="onOpen"/>
    </div>
    <div class="codeIcon" v-if="isCode">
      <PDFButton :title="codeText === 'LoginGetCode' ? $t(`${codeText}`) : codeText" color="transparent" textColor="#2590E1" customFontSize="14px" isLoginPadding paddingH="0" paddingTop="0 10px 0 0" @ButtonClick="getCode"/>
    </div>
  </div>
</template>

<script setup lang="ts">
import PDFButton from "@/components/Button/PDFButton.vue"
import {ref, defineExpose, watch, onMounted} from "vue";
import {useI18n} from "vue-i18n";
import { sanitizeCode } from "@/utils/verifyCode";
// import {getEmailAccountCode} from "@/net/upload";
const { t } = useI18n()
let bgRef = ref(false)
const inputOpen = ref(false)
const inputValue = ref("")
const inputRef = ref()
const codeText = ref("LoginGetCode");
const timeId = ref(null);
const placeholderStr = ref("");
defineExpose({ inputValue, clearInput, setInputValue })
const emit = defineEmits(['handleChange','sendCode', 'recoveryInput'])

const props = defineProps({
  inputWidth: {
    type: String,
  },
  inputHeight: {
    type: String,
  },
  placeholderString: {
    type: String,
    default: ""
  },
  isPassword: {
    type: Boolean,  // 是否是密码
    default: false
  },
  isLeftIcon: {
    type: String,
    default: null
  },
  isCode: {
    type: Boolean,  // 是否验证码
    default: false
  },
  isCodeClick: {
    type: Boolean,  // 验证码是否可以被点击
    default: true
  },
  autoComplete: {
    type: Boolean,  // 是否填充密码
    default: true
  },
  inputMaxLength: {
    type: Number,  // 输入最大长度
    default: null
  },
  inputMinLength: {
    type: Number,  // 输入最大长度
    default: null
  },
  isShowNumber: {
    type: Boolean,  // 是显示输入长度
    default: false
  },
  isDisable: {
    type: Boolean,  // 是否禁用
    default: false
  },
  defaultText: {
    type: String,  // 默认文字禁用
    default: null
  },
  refName: {
    type: String,  // inputId
    default: null
  },
  inputBorderColor: {
    type: String,  // 边框颜色
    default: null
  },
  setplaceholderStyle:{
    type: Boolean,  // 是否设置提示的样式
    default: false
  },
  isSendCode: {
    type: Boolean,  // 是否走倒计时
    default: false
  }
})

const setClassStyle = () => {
  return {
    'disableChooseSelectInput' : props.isDisable,
    'chooseSelectInput': !props.isDisable,
    'setplaceholderStyle': props.setplaceholderStyle
  }
}

watch(
    () => props.placeholderString,
    () => {
      if (props.placeholderString) {
        placeholderStr.value = props.placeholderString
      }
    },
    {
      deep: true
    }
)
watch(
    () => props.isSendCode,
    () => {
      if (props.isSendCode) {
        // 监听，是否通过正则校验邮箱的合格性，如果合格才会走倒计时，并且发送短信验证码
        codeTime()
      }
    },
    {
      deep: true
    }
)
watch(inputValue, (newValue) => {
  // 监听输入框的值，如果是密码类型的， 则不允许输入中文
  if (props.isPassword) {
    // 使用正则表达式判断是否包含中文
    const chineseRegex = /[\u4e00-\u9fa5]/;
    if (chineseRegex.test(newValue)) {
      // 如果包含中文，移除中文字符
      inputValue.value = newValue.replace(chineseRegex, "");
    }
  }
});

onMounted(()=>{
  if (props.defaultText) {
    inputValue.value = props.defaultText
  }
  placeholderStr.value = props.placeholderString
})

const getCode = async ()=>{
  if (timeId.value != null){
    return
  }
  emit("sendCode")
  if (!props.isCodeClick) {
    return
  }
  if(props.isSendCode){
    codeTime()
  }
  
}

const codeTime = ()=>{
  let time = 119;
  if(!(codeText.value === "LoginGetCode")) return;
  codeText.value = time + 'S'
  // @ts-ignore
  timeId.value = setInterval(()=>{
    if(time <= 0){
      // @ts-ignore
      clearInterval(timeId.value);
      timeId.value = null
      codeText.value = "LoginGetCode"
    }else{
      time --;
      codeText.value = time + 'S'
    }
  }, 1000)
}

function inputBlur() {
  bgRef.value = false
};
function inputFocus() {
  bgRef.value = true
  emit("recoveryInput")
};

function onClick() {
  inputRef.value.focus()
}

function onOpen() {
  inputOpen.value = !inputOpen.value
}

function setInputValue(str) {
  inputValue.value = str
}

function clearInput() {
  console.log("clearInput")
  inputValue.value = ""
}

function handleChange(value) {
  if (props.isCode) {
    inputValue.value = sanitizeCode(inputValue.value)
  }
  emit('handleChange', inputValue.value);
}

// 粘贴必须 preventDefault 后自己写值：
// 浏览器原生粘贴会先按 maxlength=6 截断再触发 input，
// 于是 " 12345" 会被截成 " 1234"，此时再清洗只剩 "1234" —— 用户看到验证码莫名少一位。
// 所以顺序必须是「先清洗、再截断、再赋值」。
function onPaste(e) {
  if (!props.isCode) return
  e.preventDefault()
  const clip = (e.clipboardData || (window as any).clipboardData)
  const text = clip ? clip.getData('text') : ''
  const max = props.inputMaxLength || 6
  inputValue.value = sanitizeCode(text).slice(0, max)
  emit('handleChange', inputValue.value)
}

</script>

<style scoped lang="scss">
.inputBg {
  background-color: #FFFFFF;
  display: flex;
  border-radius: 4px;
  align-items: center;
  position: relative;
}
.disableChooseSelectInput {
  font-size: 14px;
  padding: 0 20px;/*清除自带的padding间距*/
  border: 0;/*清除自带的2px的边框*/
  flex: 1;
  border-radius: 4px;
}
.chooseSelectInput {
  font-size: 14px;
  border: 0;/*清除自带的2px的边框*/
  padding: 0 20px;/*清除自带的padding间距*/
  outline: 1px solid #BFBFBF;
  background-color: transparent;
  flex: 1;
  border-radius: 4px;
  &:hover{
    outline:1px solid #8C8C8C;
  }
  &:focus{
    outline:1px solid #2590E1;
  }
  &:invalid{
    outline:1px solid #E14C25;
    color: #E14C25
  }
}
.chooseSelectInput::placeholder {
  color: #BFBFBF;
}
.setplaceholderStyle::placeholder{

}
.rightIcon {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  right: 0;
}

.limitation {
  font-size: 12px;
  color: var(--input-bg-color);
}

.codeIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  position: absolute;
  right: 0;
}

.icon-icon_open_n:hover {
  color: #2590E1;
}

.icon-icon_open_n:active {
  color: #2181CA;
}

.icon-icon_close_n:hover {
  color: #2590E1;
}

.icon-icon_open_n:active {
  color: #2181CA;
}

</style>
